import React, { FC, Dispatch, SetStateAction } from 'react'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'

type Props = {
  shouldLoadComponent: boolean
  setShouldLoadComponent: Dispatch<SetStateAction<boolean>>
}
const RecommendedArtworksCarousel = dynamic(
  import(
    /* webpackChunkName: "RecommendedArtworksCarousel" */
    './Carousel'
  ),
  noSSR
)

const RecommendedArtworks: FC<Props> = (props) => {
  const { shouldLoadComponent, setShouldLoadComponent } = props

  return (
    <RecommendedArtworksCarousel
      shouldLoadComponent={shouldLoadComponent}
      setShouldLoadComponent={setShouldLoadComponent}
    />
  )
}

export default RecommendedArtworks
